var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHydrogen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-537.611,-1403.09)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,-638.688,-301.926)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,16.9635,6.48236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.806248,0,0,0.452573,917.545,306.392)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 302.383,
    cy: 1395.21,
    r: 70.807,
    style: {
      fill: "rgb(63,81,181)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11098,0,0,0.623627,-182.116,734.412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1209.05,289.833C1209.05,289.833 1226.7,304.905 1231.75,312.636C1243.73,330.958 1229.75,354.245 1210.79,354.936C1191.92,355.624 1172.29,336.334 1188.1,311.56C1191.74,305.844 1209.05,289.833 1209.05,289.833Z",
    style: {
      fill: "white",
      stroke: "rgb(63,81,181)",
      strokeWidth: "1.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.43,314.622L1200.18,340.368M1218.06,314.622L1217.81,340.368M1217.81,326.122L1200.43,326.122",
    style: {
      fill: "rgb(76,82,243)",
      stroke: "rgb(63,81,181)",
      strokeWidth: "3.43px"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrogen);
export default __webpack_public_path__ + "static/media/hydrogen.8170b264d71b5bd4028087ba69ae2bc8.svg";
export { ForwardRef as ReactComponent };